import { render, staticRenderFns } from "./BreakoutRoomsSettings.vue?vue&type=template&id=5f10ed92&scoped=true"
import script from "./BreakoutRoomsSettings.vue?vue&type=script&lang=js"
export * from "./BreakoutRoomsSettings.vue?vue&type=script&lang=js"
import style0 from "./BreakoutRoomsSettings.vue?vue&type=style&index=0&id=5f10ed92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f10ed92",
  null
  
)

export default component.exports